import type { IApi } from "~/types/common";

export function useApi(): IApi {
  const { $api: api }: any = useNuxtApp();

  const toQueryString = (params: any) => {
    if (!params) return "";
    return new URLSearchParams(params).toString();
  };

  const apiCall = async <T>(
    url: string,
    method: "GET" | "POST" | "PUT" | "DELETE",
    body?: any,
    options?: any
  ): Promise<T> => {
    const config = {
      method,
      url,
      data: body,
      ...options,
    };
    const response = await api(config);
    return response;
  };

  const get = async <T>(url: string, options?: any): Promise<T> => {
    const queryString = options?.params
      ? `?${toQueryString(options.params)}`
      : "";
    return await apiCall<T>(`${url}${queryString}`, "GET");
  };

  const post = async <T>(url: string, body: any, options?: any): Promise<T> => {
    return await apiCall<T>(url, "POST", body, options);
  };

  const put = async <T>(url: string, body: any, options?: any): Promise<T> => {
    return await apiCall<T>(url, "PUT", body, options);
  };

  const del = async <T>(url: string, options?: any): Promise<T> => {
    return await apiCall<T>(url, "DELETE", undefined, options);
  };

  return { get, post, put, del };
}
